import LightBox from './LightBox'
import {getInsideWindowHeight, getInsideWindowWidth, px} from '../atBrowserUtils'

export default class FixedLightBox extends LightBox {
    centrePopup() {
        // need to set 'position: fixed' in styles
        const popup = this.getPopupEl()

        popup.css('left', px(Math.floor((getInsideWindowWidth() - popup.outerWidth()) / 2)))
        popup.css('top', px(Math.floor((getInsideWindowHeight() - popup.outerHeight()) / 2)))
    }
}



// WEBPACK FOOTER //
// ./web/js/components/FixedLightBox.js